import { PopupSelectComponent } from './popup-select.component';

export default angular
  .module('sfMobile.components.popup-select', [])
  .component('sfPopupSelect', PopupSelectComponent).name;
